import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Imports = lazy(() => import('./Imports'))

export const OperationsFuelPricesRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations--fuel-prices']}>
    <Route index element={<Index />} />
    <Route path='imports' element={<Imports />} />
  </SubRouter>
))
